/**
 * Tenant passkeys — Zod schemas.
 *
 * Admin view of every passkey registered inside a tenant,
 * aggregated across all users. Distinct from the per-user passkey
 * panel (features/users/components/user-passkeys-panel.tsx) which
 * shows only one user's credentials.
 */

import { z } from "zod";

export const passkeysListSearchSchema = z.object({
  q: z.string().optional(),
  user_id: z.string().optional(),
  backup_state: z.enum(["synced", "device_bound"]).optional(),
  sortBy: z.enum(["created_at", "last_used_at", "user_email"]).optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  offset: z.coerce.number().int().nonnegative().optional(),
});
export type PasskeysListSearch = z.infer<typeof passkeysListSearchSchema>;

export const tenantPasskeySchema = z.object({
  id: z.string(),
  user_id: z.string(),
  user_email: z.string(),
  friendly_name: z.string().nullable(),
  aaguid: z.string().nullable(),
  authenticator_name: z.string().nullable(),
  transports: z.array(z.string()),
  backup_eligible: z.boolean(),
  backup_state: z.boolean(),
  created_at: z.string(),
  last_used_at: z.string().nullable(),
  sign_count: z.number().int().nonnegative(),
});
export type TenantPasskey = z.infer<typeof tenantPasskeySchema>;

export const tenantPasskeysListResponseSchema = z.object({
  data: z.array(tenantPasskeySchema),
  pagination: z.object({
    total: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
  }),
});
export type TenantPasskeysListResponse = z.infer<
  typeof tenantPasskeysListResponseSchema
>;
